import styled from 'styled-components';

export const NavContainer = styled.div`
width: 100%;
background-color: #FFF;
box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
height: 100px;
position: fixed;
top: 0;
display: flex;
align-items: center;
z-index: 99;

@media (max-width: 667px) {
    height: 75px;
}
`
export const Logo = styled.a`
  margin-left: 8%;

  img {
      height: 70px;
      width: auto;

      @media (max-width: 667px) {
          height: 50px;
      }
      
      @media (max-width: 400px) {
          height: 35px;
      }
  }
`

export const MenuItemsContainer = styled.div`
    position: absolute;
    top: 26px;
    right: 20px;

    @media (max-width: 500px) {
        top: 15px;
        right: 5px;
      }
`;

export const PaymentActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    text-decoration: none;
  }
`;

export const CaptchaBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.55);
`;

export const CaptchaDialog = styled.div`
  width: 100%;
  max-width: 390px;
  padding: 24px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);

  p {
    margin: 16px 0 20px;
    color: #333;
    line-height: 1.5;
  }
`;

export const CaptchaHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const CaptchaCloseButton = styled.button`
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #333;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
`;

export const CaptchaContainer = styled.div`
  min-height: 78px;

  @media (max-width: 380px) {
    transform: scale(0.86);
    transform-origin: left top;
    margin-bottom: -11px;
  }
`;
